import { useMemo } from 'react';
import { Card, Body1, SectionHeader } from '../../blocks';
import { genOriginAttributes } from '@onward-delivery/core';
import { toNational } from '@/utilities/formatPhoneNumber';
import { toFullState } from '@/utilities/address';
import { startCase } from 'lodash';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

const OrderOriginCard = ({ claim, order }) => {
    const isReturn = useMemo(() => {
        return ['return', 'wh_return'].includes(order?.order_type);
    }, [order]);

    const { name, phone, email, location_type, address } = useMemo(() => {
        const { street, unit, city, state, zip, location, location_info, location_type } = genOriginAttributes(
            order,
            !!claim.middle_mile_carrier_id
        );
        return {
            ...(!!claim.middle_mile_carrier_id
                ? {
                      name: isReturn ? order.pickup_name : order.middle_mile_origin_name,
                      phone: isReturn ? order.pickup_phone : order.middle_mile_origin_phone,
                      email: isReturn ? order.pickup_email : order.middle_mile_origin_email,
                  }
                : {
                      name: isReturn ? order.dropoff_name : order.pickup_name,
                      phone: isReturn ? order.dropoff_phone : order.pickup_phone,
                      email: isReturn ? order.dropoff_email : order.pickup_email,
                  }),
            location_type: [location, location_info, location_type]
                .map((attr) => (attr ? order[attr] : null))
                .filter((x) => !!x)
                .map((val) => startCase(val))
                .join(', '),
            address: `${order[street]}${order[unit] ? ` ${order[unit]}` : ''} ${order[city]}, ${toFullState(order[state])} ${
                order[zip]
            }`,
        };
    }, [order, isReturn]);

    const comments = useMemo(() => {
        return (order?.notes || [])
            .filter((note) => note.type === 'Pickup' && !note.private_to)
            .map((note) => note.note)
            .filter((x) => !!x)
            .join('\n');
    }, [order]);

    return (
        <Card>
            <Grid
                item
                css={css`
                    margin-bottom: 1rem;
                `}
            >
                <SectionHeader>{isReturn ? 'Return Pickup' : 'Pickup'}</SectionHeader>
            </Grid>
            <Grid item>
                <Body1>{name}</Body1>
            </Grid>
            <Grid item>
                <Body1>{toNational(phone)}</Body1>
            </Grid>
            <Grid item>
                <Body1>{email}</Body1>
            </Grid>
            <Grid item>
                <Body1>{address}</Body1>
            </Grid>
            <Grid item>
                <Body1>{location_type}</Body1>
            </Grid>
            <Grid item>
                <Body1>Comments: {comments || '--'}</Body1>
            </Grid>
        </Card>
    );
};

export default OrderOriginCard;
